import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import getNgModule from "getNgModule";
import tinymce from "tinymce/tinymce";
import "modules/core/tinymce/langs/fr_FR";
var ngModule = getNgModule(__filename);

// console.log("** tinyMCE = ", tinymce);

// UI-tinyMCE
// https://github.com/angular-ui/ui-tinymce/blob/master/src/tinymce.js

ngModule.directive("tlRichtextEditor", function ($authz) {
  return {
    restrict: "E",
    replace: true,
    scope: {},
    bindToController: {},
    require: ["tlRichtextEditor", "?ngModel"],
    template: "\n            <div class=\"tl-richtext-editor\">\n                <div class=\"tl-richtext-content\"></div>\n            </div>\n        ",
    link: function link($scope, $el, $attrs, ctrls) {
      var _ctrls = _slicedToArray(ctrls, 2),
        ctrl = _ctrls[0],
        ngModelCtrl = _ctrls[1];
      ctrl.setNgModel(ngModelCtrl);
    },
    controller: /*#__PURE__*/function () {
      function RichTextInputController($element, $sce) {
        'ngInject';

        _classCallCheck(this, RichTextInputController);
        this.$element = $element;
        this.$sce = $sce;
      }
      return _createClass(RichTextInputController, [{
        key: "setNgModel",
        value: function setNgModel(ngModel) {
          var _this = this;
          var $sce = this.$sce;
          this.ngModel = ngModel;
          ngModel.$formatters.unshift(function (modelValue) {
            return modelValue ? $sce.trustAsHtml(modelValue) : '';
          });
          ngModel.$parsers.unshift(function (viewValue) {
            return viewValue ? $sce.getTrustedHtml(viewValue) : '';
          });
          ngModel.$render = function () {
            var editor = _this.getEditor();
            // instance.getDoc() check is a guard against null value
            if (editor && editor.getDoc()) {
              var viewValue = ngModel.$viewValue ? $sce.getTrustedHtml(ngModel.$viewValue) : '';
              editor.setContent(viewValue);
              // Triggering change event due to TinyMCE not firing event & becoming out of sync for change callbacks
              editor.fire('change');
            }
          };
        }
      }, {
        key: "updateView",
        value: function updateView() {
          var editor = this.getEditor();
          var content = editor.getContent({
            format: "html"
          }).trim();
          content = this.$sce.trustAsHtml(content);

          // console.log("updateView ->", content);

          this.ngModel.$setViewValue(content);

          /*
          ngModel.$setViewValue(content);
          if (!$rootScope.$$phase) {
              scope.$digest();
          }
          */
        }
      }, {
        key: "getEditor",
        value: function getEditor() {
          if (this.editor == null) {
            this.editor = tinymce.get(this.editorId);
          }
          return this.editor;
        }
      }, {
        key: "$onDestroy",
        value: function $onDestroy() {
          // console.log("*** on destroy !");
          if (this.editor) {
            this.editor.remove();
            this.editor = null;
          }
        }
      }, {
        key: "$onInit",
        value: function $onInit() {
          var _this2 = this;
          console.log("onInit", this);

          // console.log("*ONINIT")

          this.editorId = _.uniqueId("tl-rich-text");
          this.$element.find(".tl-richtext-content").attr("id", this.editorId);
          if (this.$element.attr('macros')) {
            this.showMacros = true;
          }
          var debouncedUpdateView = function debouncedUpdateView() {};
          var editor = tinymce.init({
            selector: "#" + this.editorId,
            language: 'fr_FR',
            height: 350,
            menubar: false,
            statusbar: false,
            branding: false,
            theme: "modern",
            skin: false,
            plugins: ['textcolor colorpicker autolink lists link paste table'],
            toolbar: [(this.showMacros ? 'macro | ' : '') + 'bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link | table tableinsertdialog tablecellprops tableprops'],
            /*content_css: [
                '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
                '//www.tinymce.com/css/codepen.min.css']*/
            setup: function setup(ed) {
              ed.on('init', function () {
                _this2.ngModel.$render();
              });
              if (_this2.showMacros) {
                // idealement cette liste devrait être injectée sur la directive, mais j'ai pas réussi à faire cela pour le moment.
                var macros = [{
                  text: 'Budget',
                  items: [{
                    macro: '{budget=INDIQUEZ LE NOM DU BUDGET ICI}',
                    text: 'Change le budget pour la suite du commentaire. Exemple : {Budget=Eau}'
                  }, {
                    macro: '{nom-budget}',
                    text: 'Affiche le nom du budget courant. Si aucun n\'a été choisi, alors affiche \'Tous\''
                  }]
                }];
                macros.push({
                  text: 'Dates',
                  items: [{
                    macro: '{date-visualisation}',
                    text: 'Date de visualisation'
                  }, {
                    macro: '{annee}',
                    text: 'Année de la date de visualisation'
                  }, {
                    macro: '{date-cloture-exercice}',
                    text: 'Date de clôture de l\'exercice'
                  }]
                });
                if ($authz.hasAnyRole("MODULE_DETTE_GARANTIE", "MODULE_DETTE", "MODULE_PLACEMENT", "MODULE_PRET")) {
                  macros.push({
                    text: 'Durées',
                    items: [{
                      macro: '{duration}',
                      text: 'Duration'
                    }, {
                      macro: '{duree-residuelle}',
                      text: 'Durée résiduelle'
                    }, {
                      macro: '{duree-residuelle-moyenne}',
                      text: 'Durée résiduelle moyenne'
                    }]
                  });
                }
                if ($authz.hasAnyRole("MODULE_DETTE_GARANTIE", "MODULE_DETTE", "MODULE_PLACEMENT", "MODULE_PRET")) {
                  macros.push({
                    text: 'Portefeuille',
                    items: [{
                      macro: '{nombre-produits-vivants}',
                      text: 'Nombre de produits non échus'
                    }, {
                      macro: '{nombre-emprunts-vivants}',
                      text: 'Nombre d\'emprunts non échus'
                    }, {
                      macro: '{crd}',
                      text: 'CRD à date de visualisation'
                    }, {
                      macro: '{amortissements-annee}',
                      text: 'Amortissements de l\'année de visualisation'
                    }, {
                      macro: '{interets-annee}',
                      text: 'Intérêts de l\'année de visualisation'
                    }, {
                      macro: '{annuites-annee}',
                      text: 'Annuités de l\'année de la date de visualisation'
                    }, {
                      macro: '{icne-exercice}',
                      text: 'ICNE de l\'exercice'
                    }, {
                      macro: '{taux-moyen-exercice}',
                      text: 'Taux moyen de l\'exercice (base exact/exact)'
                    }, {
                      macro: '{taux-moyen-sur-12-mois}',
                      text: 'Taux moyen sur les 12 prochains mois (base exact/exact)'
                    }]
                  });
                }
                if ($authz.hasAnyRole("MODULE_DETTE_GARANTIE", "MODULE_DETTE", "MODULE_PLACEMENT", "MODULE_PRET")) {
                  macros.push({
                    text: 'Risque',
                    items: [{
                      macro: '{part-taux-fixe}',
                      text: 'Part de l\'encours taux fixe à la date de visualisation'
                    }, {
                      macro: '{part-taux-variable}',
                      text: 'Part de l\'encours taux varibale et structuré à la date de visualisation'
                    }
                    //{macro: '{nombre-produits-taux-fixe-vivants}', text: 'Nombre de produits non échus'},
                    //{macro: '{nombre-produits-taux-variable-vivants}', text: 'Nombre de produits non échus'},
                    ]
                  });
                }
                if ($authz.hasRole("MODULE_DETTE_GARANTIE")) {
                  macros.push({
                    text: 'Dette garantie',
                    items: [{
                      macro: '{encours-garanti-galland}',
                      text: 'Encours garanti sous loi Galland'
                    }, {
                      macro: '{encours-garanti-hors-galland}',
                      text: 'Encours garanti hors loi Galland'
                    }, {
                      macro: '{duree-residuelle-moyenne-dette-garantie}',
                      text: 'Durée résiduelle moyenne de la dette garantie'
                    }]
                  });
                }
                var menuItems = [];
                macros = _.sortBy(macros, ['text']);
                var _iterator = _createForOfIteratorHelper(macros),
                  _step;
                try {
                  var _loop = function _loop() {
                    var macroEntry = _step.value;
                    // menu
                    if (macroEntry.items) {
                      var menuRoot = {
                        text: macroEntry.text
                      };
                      // ajout sous menus

                      var subMenu = [];
                      var _iterator2 = _createForOfIteratorHelper(macroEntry.items),
                        _step2;
                      try {
                        var _loop2 = function _loop2() {
                          var item1 = _step2.value;
                          subMenu.push({
                            text: item1.text,
                            onclick: function onclick() {
                              ed.insertContent(item1.macro);
                            }
                          });
                        };
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                          _loop2();
                        }
                      } catch (err) {
                        _iterator2.e(err);
                      } finally {
                        _iterator2.f();
                      }
                      subMenu = _.sortBy(subMenu, ['text']);
                      menuRoot.menu = subMenu;
                      menuItems.push(menuRoot);
                    } else {
                      menuItems.push({
                        type: 'menuitem',
                        text: macroEntry.text,
                        onclick: function onclick() {
                          ed.insertContent(macroEntry.macro);
                        }
                      });
                    }
                  };
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                ed.addButton('macro', {
                  type: 'menubutton',
                  text: 'Macros',
                  icon: false,
                  menu: menuItems
                });
              }
              ed.on('change ExecCommand NodeChange ObjectResized', function (e) {
                // console.log('the editor object ', ed);
                // console.log('the content ', ed.getContent());

                ed.save();
                _this2.updateView();
              });
            }
          });
        }
      }]);
    }()
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/richtext/tl-richtext-editor.js
// module id = 2987
// module chunks = 13